export default __webpack_public_path__ + "static/3p9-3d-seg-30c53bd61ef24cc6552cae7c91b08e69.png";